import { getAllCustomers } from "@/api";
import { CustomerRead } from "@types";
import { useInfiniteList } from "@hooks";

export const CUSTOMERS_QK = ["customers"] as const;

export function useAllCustomers() {
  return useInfiniteList<CustomerRead>({
    queryKey: CUSTOMERS_QK,
    fetchFn: async (page) => {
      const res = await getAllCustomers(page);
      return res.data;
    },
  });
}
